import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Badge, Table} from 'react-bootstrap';
import {EPathname} from '../../const/dataEnum';
import LoadingComponent from '../../components/LoadingComponent';
import {employeeReviewBusiness} from '../../stores/business/employeeReviewBusiness';
import {FmlxBanner, FmlxButton, FmlxIcon} from 'fmlx-common-ui';
import {FMLX_BANNER, FMLX_BUTTON, FMLX_COMPONENT} from '../../const/FmlxComponentEnum';

export default function Consolidation() {
  const history = useHistory();

  const [myConsolidatedReviewsLoading, setMyConsolidatedReviewsLoading] = useState(true);
  const [myConsolidatedReviews, setMyConsolidatedReviews] = useState([]);
  const [bannerState, setBannerState] = useState({
    show: false,
    title: '',
    variant: FMLX_BANNER.Variant.INFO,
  });

  useEffect(() => {
    fetchMyConsolidatedReviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMyConsolidatedReviews = async () => {
    const consolidatedReview = await employeeReviewBusiness.getMyConsolidatedReview();
    if (consolidatedReview.responseCode === 0) {
      setMyConsolidatedReviews(consolidatedReview.data);
      console.log('consolidation data list', consolidatedReview.data);
    } else {
      setBannerState({
        show: true,
        title: 'You do not have consolidated review yet',
        variant: FMLX_BANNER.Variant.INFO,
      });
    }
    setMyConsolidatedReviewsLoading(false);
  };

  async function showConsolidatedReview(employeeId, periodId, periodName) {
    history.push({
      pathname: EPathname.CONSOLIDATION_VIEW,
      state: {
        employeeId,
        periodId,
        periodName,
      },
    });
  }

  const onBannerCloseClickHandler = () => {
    setBannerState((s) => ({...s, show: false}));
  };

  function tabel(data, loading) {
    return (
      <div>
        <Table hover className="mb-4 mt-2">
          <thead>
          <tr>
            <th className="text-center align-middle" width="100">
              Period
            </th>
            <th className="align-middle" width="*">
              Consolidator
            </th>
            <th className="text-center align-middle" width="100">
              Status
            </th>
            <th className="text-center align-middle" width="200">
              Actions
            </th>
          </tr>
          </thead>
          <tbody>
          {myConsolidatedReviewsLoading ? (
            <tr>
              <td className="text-center align-middle" colSpan="5">
                {<LoadingComponent/>}
              </td>
            </tr>
          ) : !data ? (
            <tr>
              <td className="text-center align-middle" colSpan="5">
                No data yet, please check again later
              </td>
            </tr>
          ) : (
            data.map((review) => (
              <tr key={review.id}>
                <td className="text-center align-middle">{review.reviewPeriod.period}</td>
                <td className="align-middle">{review.reviewedBy.fullName}</td>
                <td className="text-center align-middle">
                  {review.released ? <Badge bg="success">Done</Badge> : <Badge bg="secondary">In progress</Badge>}
                </td>
                <td className="text-center align-middle" style={{whiteSpace: 'nowrap'}}>
                  <FmlxButton
                    size={FMLX_COMPONENT.SIZE.M}
                    variant={FMLX_BUTTON.VARIANT.OUTLINE}
                    label="View"
                    onClick={() => {
                      showConsolidatedReview(
                        review.employeeReviewedID,
                        review?.reviewPeriodID,
                        review?.reviewPeriod?.period
                      );
                    }}
                    withIcon={FMLX_BUTTON.WITH_ICON.END}
                    icon={<FmlxIcon name={'Eye'}/>}
                  ></FmlxButton>
                </td>
              </tr>
            ))
          )}
          </tbody>
        </Table>
      </div>
    );
  }

  return (
    <div className="consolidated-review-container">
      <FmlxBanner
        show={bannerState.show}
        variant={bannerState.variant}
        title={bannerState.title}
        onCloseClick={onBannerCloseClickHandler}
      />
      {tabel(myConsolidatedReviews, myConsolidatedReviewsLoading)}
    </div>
  );
}
